import ErrorBoundary from '~/components/experimental/ErrorBoundary/ErrorBoundary'
import { loadLayout } from '~/utils/loaders/layoutLoader'

interface layoutData {
  type: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any
}

interface ComponentRendererProps {
  components: layoutData[]
  avantGarde?: boolean
}

export function ComponentRenderer({
  components,
  avantGarde = false
}: ComponentRendererProps) {
  let prevCol = ''
  let padding = ''

  return (
    <>
      {components.map((layoutData, index) => {
        // Load the correct layout component
        const Component = loadLayout(layoutData?.type)

        // Check if the background colour has changed
        const currentCol = layoutData?.value?.backgroundColour

        if (prevCol === currentCol) {
          padding =
            currentCol !== 'white' && currentCol !== null
              ? 'small-alt'
              : 'large-alt'
        } else {
          padding =
            currentCol !== 'white' && currentCol !== null ? 'small' : 'large'
        }
        prevCol = currentCol

        return (
          <ErrorBoundary key={`${layoutData?.type}-${index}`}>
            <Component
              content={layoutData?.value}
              padding={padding as Padding}
              avantGarde={avantGarde}
            />
          </ErrorBoundary>
        )
      })}
    </>
  )
}
